import { RectangleHitbox } from "./hitbox";
import { Vec } from "./vector";

// Outside the deck edge: keep the original 5-unit yacht passage walkable.
export const yachtGangwayRails = [RectangleHitbox.fromRect(35.5, 0.5, Vec(10.25, 9.5)), RectangleHitbox.fromRect(35.5, 0.5, Vec(10.25, 15.5))];
export const tugGangwayRails = [RectangleHitbox.fromRect(4.5, 0.6, Vec(68.15, -29)), RectangleHitbox.fromRect(4.5, 0.6, Vec(68.15, -18.4))];
export const dockGangwayRails = [RectangleHitbox.fromRect(0.7, 39.3, Vec(7.37, -9.54)), RectangleHitbox.fromRect(0.7, 39.3, Vec(21.88, -9.54)), RectangleHitbox.fromRect(45.64, 0.7, Vec(-15.45, 8.8)), RectangleHitbox.fromRect(16.4, 0.7, Vec(30.1, 8.8))];
export const riverHutGangwayRails = [RectangleHitbox.fromRect(0.7, 10.5, Vec(25, -22.75)), RectangleHitbox.fromRect(0.7, 21.5, Vec(25, 7.25)), RectangleHitbox.fromRect(0.7, 46, Vec(38, -5))];

/** Static visible rails use the same rectangles as server collision, plus a small highlight. */
export function gangwayRailGraphics(rails: readonly RectangleHitbox[]): { color: number, hitbox: RectangleHitbox }[] {
    return rails.flatMap(hitbox => {
        const min = hitbox.min, max = hitbox.max, horizontal = max.x - min.x > max.y - min.y;
        const highlight = new RectangleHitbox(Vec(min.x + 0.1, min.y + 0.1), Vec(max.x - (horizontal ? 0.1 : 0.3), max.y - (horizontal ? 0.3 : 0.1)));
        return [{ color: 0x354e51, hitbox }, { color: 0xd8c794, hitbox: highlight }];
    });
}
